export var MultiSearchControlsSubject;
(function (MultiSearchControlsSubject) {
    MultiSearchControlsSubject["Cancel"] = "cancel-filter-selection";
    MultiSearchControlsSubject["Apply"] = "apply-filter-selection";
    MultiSearchControlsSubject["SelectAll"] = "select-all-options";
    MultiSearchControlsSubject["Clear"] = "clear-selected-options";
})(MultiSearchControlsSubject || (MultiSearchControlsSubject = {}));
export var SearchFiltersClearButtonSubject;
(function (SearchFiltersClearButtonSubject) {
    SearchFiltersClearButtonSubject["Clear"] = "clear-filters";
})(SearchFiltersClearButtonSubject || (SearchFiltersClearButtonSubject = {}));
export var SearchFilterType;
(function (SearchFilterType) {
    SearchFilterType["Boolean"] = "Boolean";
    SearchFilterType["Toggle"] = "Toggle";
    SearchFilterType["Select"] = "Select";
    SearchFilterType["MultiSelect"] = "MultiSelect";
    SearchFilterType["DateRangePicker"] = "DateRangePicker";
    SearchFilterType["SuperDateRangePicker"] = "SuperDateRangePicker";
})(SearchFilterType || (SearchFilterType = {}));
export var SearchQueryFilterSubjects;
(function (SearchQueryFilterSubjects) {
    SearchQueryFilterSubjects["MultiFilterEdit"] = "multi-filter-edit";
    SearchQueryFilterSubjects["MultiFilter"] = "multi-filter-element";
})(SearchQueryFilterSubjects || (SearchQueryFilterSubjects = {}));
//# sourceMappingURL=searchFilters.enum.js.map